<template>
  <div
    ref="wrap"
    class="calendar-week-task"
    v-clickoutside="cleanLayer"
    @click.self="createTask"
  >
    <div
      v-for="(item, pindex) in results"
      :key="pindex"
      class="calendar-week-task-block"
    >
      <template v-for="task in item.tasks">
        <div
          v-if="task.name"
          :key="task.id"
          class="calendar-week-task-item"
          :class="{
            'calendar-week-task-item__schedule': task.isSchedule,
            'calendar-week-task-item__stick': task.stick,
            'calendar-week-task-item__done': task.state === 1,
            'calendar-week-task-item__dragging': task.id === daraggingTask,
            'triggered': task.triggered
          }"
          :style="{
            top: `${task.ptop + 3}px`,
            height: `${task.height - 3}px`,
            width: `calc(${100/item.width}% - 4px)`,
            left: `calc(${task.pleft*100/item.width}% + 2px)`
          }"
          @click="task.triggered = true, $event.stopPropagation()"
        >
          <div draggable="false">
            <el-popover
              v-model="task.triggered"
              placement="right"
              trigger="hover"
            >
              <div
                slot="reference"
                class="calendar-week-task-text"
                :class="{
                  'short-task': task.isShort
                }"
              >
                <div class="calendar-week-task-label">
                  <div
                    v-show="task.state === 1"
                    class="ibass ibass-done"
                  ></div>
                  {{ task.name || '' }}
                </div>
              </div>
              <!-- 任务详情 -->
              <task-info
                v-if="task.triggered"
                :task="task"
                @close="task.triggered = false"
              />
            </el-popover>
          </div>
        </div>
      </template>
    </div>
    <hours-layer
      :iLayerY="iLayerY"
      :iLayerH="iLayerH"
      :iLabel="label"
      :theme="theme"
      @dragEnd="createTaskBySlide"
      @click="comfirCreate"
      @changeTheme="changeTheme"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import TaskInfo from './taskInfo'
import HoursLayer from './hoursLayer'
import clickoutside from '@/directives/clickoutside'
import { TASK_DETAIL } from '@/utils/constants'
/* eslint-disable-next-line */
import Worker from 'workerize-loader!@/plugin/worker/calendar'
export default {
  name: 'CalendarTaskBlock',
  components: {
    TaskInfo,
    HoursLayer
  },
  directives: {
    clickoutside
  },
  props: {
    tasks: {
      type: Array,
      default () {
        return []
      }
    },
    isMore: Boolean
  },
  data () {
    return {
      results: [],
      targetNode: {},
      iLayerY: 0,
      iLayerH: 0,
      label: '',
      daraggingTask: 0,
      TASK_DETAIL,
      theme: ''
    }
  },
  watch: {
    tasks (newVal) {
      this.items = _.cloneDeep(newVal)
      this.setTopAndHeight()
    }
  },
  methods: {
    changeTheme (theme) {
      this.theme = theme
    },
    /**
     * 创建任务
     * 如果当前有任务详情弹出框，则返回;
     * 如果点击时页面存在其他要新建的任务，则置空
     */
    createTask (event, fromParent = false) {
      if (this.$refs.wrap.querySelectorAll('.triggered').length) {
        return
      }
      this.iLayerY = this.transformDate(event.layerY)
      this.iLayerH = this.iLayerH ? 0 : 30
      this.label = '新建任务'
      this.theme = 'theme-create'
    },
    showTaskDetail (task, event) {
      this.$postMessage.openTaskDetail(task.id)
      event.stopPropagation()
    },
    comfirCreate (event) {
      this.$emit('createTask', {
        startTime: this.iLayerY,
        height: this.iLayerH
      })
    },
    cleanLayer ($event) {
      this.iLayerH = 0
      this.iLabel = ''
      this.theme = ''
    },
    stopPropagation (event) {
      event.stopPropagation()
    },
    // 拖拽区域的增减最小单位为30分钟
    transformDate (y) {
      y = Math.min(y, 24 * 60)
      y = Math.max(0, y)
      return Math.floor(y / 30) * 30
    },
    /**
     * 滑动新建任务
     */
    createTaskBySlide (params) {
      params.timeType = TASK_DETAIL.TIME_TYPE_CALENDAR
      this.$emit('createTask', params)
    },
    setTopAndHeight () {
      if (!this.calendarWorker) {
        this.calendarWorker = Worker()
      }
      this.calendarWorker.getTasksByWeek(this.items, this.isMore).then(res => {
        if (res.type === 'calendarWeekTasks') {
          this.results = res.array || []
        }
      })
      // let tmp = this.sortArray(this.items)
      // let gTmp = this.groupByStartTime(tmp)
      // this.results = this.setOrder(gTmp)
    }
    // sortArray (arr) {
    //   arr.map(item => {
    //     // 判断日程
    //     item.isSchedule = !!item.dueTime
    //     item.used = false
    //     item.isShort = !!item.dueTime || moment(item.endTime).diff(moment(item.startTime), 'minute') <= 30
    //     const dueMoment = moment(Math.floor(item.dueTime / 1000 / 60 / 30) * 1000 * 60 * 30)
    //     item.iStartTime = item.startTime || dueMoment.valueOf()
    //     item.iEndTime = item.endTime
    //       ? Math.max(moment(item.iStartTime).add(30, 'minutes').valueOf(), item.endTime)
    //       : dueMoment.add(30, 'minutes').valueOf()
    //     // 增加一个控制详情
    //     // this.$set(item, 'triggered', false)
    //     // item.triggered = false
    //   })
    //   return _.orderBy(arr, ['iStartTime', 'iEndTime'], ['asc', 'desc'])
    // },
    // groupByStartTime (arr) {
    //   let pointer = -1
    //   let max = 0
    //   let result = []
    //   let maxItems = []
    //   arr.map((item) => {
    //     if (item.iStartTime >= max) {
    //       result[++pointer] = {}
    //       result[pointer].tasks = [].concat(item)
    //       if (item.iStartTime === max) {
    //         maxItems.map((item) => { item.stick = true })
    //         maxItems = []
    //       }
    //     } else {
    //       if (result[pointer] && result[pointer].tasks) {
    //         result[pointer].tasks.push(item)
    //       }
    //     }
    //     max = Math.max(item.iEndTime, max)
    //     if (item.iEndTime === max) {
    //       maxItems.push(item)
    //     }
    //   })
    //   return result
    // },
    // setOrder (arr) {
    //   let gTemp = arr
    //   for (let i = 0; i < gTemp.length; i++) {
    //     gTemp[i].width = gTemp[i].tasks.length

    //     // 排除无效任务
    //     if (!gTemp[i].tasks[gTemp[i].tasks.length - 1].name) {
    //       gTemp[i].width = gTemp[i].width - 1
    //     }

    //     let _tasks = gTemp[i].tasks
    //     for (let j = 0; j < _tasks.length; j++) {
    //       _tasks[j].pleft = j
    //       _tasks[j].height = Math.max(moment(_tasks[j].iEndTime).diff(moment(_tasks[j].iStartTime), 'minute'), 30)
    //       _tasks[j].ptop = moment(_tasks[j].iStartTime).diff(moment(_tasks[j].iStartTime).startOf('day'), 'minute')
    //       // 再次根据pleft字段排序
    //       const leftArray = _.orderBy(_tasks.slice(0, j), ['pleft'], ['asc'])
    //       for (let k = 0; k < leftArray.length; k++) {
    //         leftArray[k].stick = leftArray[k].stick || _tasks[j].iStartTime === leftArray[k].iEndTime
    //         if (!leftArray[k].used && _tasks[j].iStartTime >= leftArray[k].iEndTime) {
    //           _tasks[j].pleft = Math.min(leftArray[k].pleft, _tasks[j].pleft || 0)
    //           gTemp[i].width--
    //           leftArray[k].used = true
    //           break
    //         } else {
    //           _tasks[j].pleft = leftArray[k].pleft + 1
    //         }
    //       }
    //     }
    //   }
    //   return gTemp
    // }
  }
}
</script>
<style lang="stylus">
.calendar-week-task
  position absolute
  left 2px
  right 2px
  height 100%
  top 6px
  z-index 20
  &-item
    background-color #FCF4DB
    color #ed6c00
    position absolute
    border-radius 2px
    cursor pointer
    &.triggered
      background-color #FFD9B9
    &.calendar-week-task-item__schedule:not(.calendar-task-block-item__done)
      display flex
      flex-direction row
      justify-content center
      align-items center
      flex-wrap nowrap
      &:after
        content ''
        position absolute
        top 0
        left 0
        right 0
        height 2px
        // background-color rgba(237,108,0,0.6)
    &.calendar-week-task-item__done
      background-color #f3f3f3
      border unset
      color #999
      .calendar-week-task-label
        text-decoration line-through
      .ibass-done
        display inline-block
        color #a9a9a9
        background-color unset
        vertical-align -2px
  &-label
    width 100%
    padding 3px
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    overflow hidden
    text-overflow ellipsis
    word-break break-all
    font-size 10px
    box-sizing border-box
  &-text
    &.short-task .calendar-week-task-label
      word-break normal
      -webkit-line-clamp 1
</style>
